"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConsultation } from "../../../../context/ConsultationContext";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import ConsultationHeader from "../components/ConsultationHeader";
import styles from "../css/treatment-plan.module.css";
import {
  getConsultationFull,
} from "../../../../api/clinic/consultationApi.js";

export default function TreatmentPlan() {
  const navigate = useNavigate();
  const { consultationData, previousStep, nextStep, updateConsultationData, getStepDraft, setStepDraft } = useConsultation();
  const [saving, setSaving] = useState(false);

  const draftKey = "treatmentPlan";
  
  const defaultFormData = {
    lifestyleAdvice: "",
    procedures: "",
    notes: "",
    patientInstructions: ""
  };

  const [formData, setFormData] = useState(() => getStepDraft(draftKey, defaultFormData));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const next = { ...prev, [name]: value };
      setStepDraft(draftKey, next);
      return next;
    });
  };

  const handlePrevious = () => {
    previousStep();
    navigate("/customer/clinic/problem-list");
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const id = consultationData?.consultationId;
        if (!id) return;
        const full = await getConsultationFull(id);
        const t = full?.consultation_treatment_plan;
        if (!t || cancelled) return;

        const existingDraft = getStepDraft(draftKey, null);
        if (existingDraft) return;

        const next = {
          ...defaultFormData,
          lifestyleAdvice: t.lifestyleadvice ?? "",
          procedures: t.procedures ?? "",
          notes: t.notes ?? "",
          patientInstructions: t.patientinstructions ?? "",
        };

        setFormData(next);
        setStepDraft(draftKey, next);
      } catch (e) {
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [consultationData?.consultationId]);

  const handleNext = async () => {
    try {
      setSaving(true);
      nextStep();
      navigate("/customer/clinic/prescription");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      
      <main className={styles.mainContent}>
        <div className={styles.container}>
          <ConsultationHeader 
            variant="step"
            currentStep={8}
            totalSteps={10}
            stepTitle="Treatment & Plan"
            stepDetails="Step 8 of 10 · Maria van der Merwe · General Consultation"
            onPrevious={handlePrevious}
            onNext={handleNext}
            nextDisabled={saving}
          />

          <div className={styles.formContainer}>
            {/* TREATMENT PLAN */}
            <div className={styles.sectionCard}>
              <h3 className={styles.blueSubHeader}>TREATMENT PLAN</h3>
              
              {/* Lifestyle Advice and Procedures (Same Row) */}
              <div className={styles.treatmentRow}>
                {/* Lifestyle Advice */}
                <div className={styles.treatmentItem}>
                  <label>Lifestyle Advice</label>
                  <textarea 
                    name="lifestyleAdvice"
                    value={formData.lifestyleAdvice}
                    onChange={handleInputChange}
                    placeholder="Diet, exercise, habits..."
                    className={styles.fullWidthTextarea}
                  />
                </div>

                {/* Procedures */}
                <div className={styles.treatmentItem}>
                  <label>Procedures</label>
                  <textarea 
                    name="procedures"
                    value={formData.procedures}
                    onChange={handleInputChange}
                    placeholder="Procedures performed or ordered..."
                    className={styles.fullWidthTextarea}
                  />
                </div>
              </div>
            </div>

            {/* NOTES and PATIENT INSTRUCTIONS (Same Row) */}
            <div className={styles.notesRow}>
              {/* NOTES */}
              <div className={styles.notesItem}>
                <h3 className={styles.blueSubHeader}>NOTES</h3>
                <textarea 
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  placeholder="Internal clinical notes..."
                  className={styles.fullWidthTextarea}
                />
              </div>

              {/* PATIENT INSTRUCTIONS */}
              <div className={styles.notesItem}>
                <h3 className={styles.blueSubHeader}>PATIENT INSTRUCTIONS</h3>
                <textarea 
                  name="patientInstructions"
                  value={formData.patientInstructions}
                  onChange={handleInputChange}
                  placeholder="Instructions for the patient..."
                  className={styles.fullWidthTextarea}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
